<!-- PrivacyDialog.vue -->
<template>
  <el-dialog title="重要提醒" :visible="visible" width="50%" @close="handleClose" @update:visible="updateVisible">
    <div class="richText-content">
      <quill-editor v-model:content="reminderHtml" :options="editorOption" contentType="html" readonly
        @focus="onEditorFocus($event)" @change="onEditorChange($event)" />
    </div>
  </el-dialog>
</template>

<script>
// 引入vue-quill-editor
import { quillEditor } from "vue-quill-editor";
// 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: 'PrivacyDialog',
  components: { quillEditor },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    reminderHtml: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      editorOption: {
        theme: 'snow', // 主题风格
        modules: {
          toolbar: false, // 设置为false以隐藏工具栏
        },
        readOnly: true, // 禁止编辑
        // bounds: document.body,
        debug: 'warn',
      },
    }
  },
  methods: {
    onEditorFocus(editor) {
      editor.enable(false);
    },
    onEditorChange(editor) {
      editor.quill.enable(false);
    },
    handleClose() {
      this.$emit('update:visible', false); // 手动关闭
    },
    updateVisible(val) {
      this.$emit('update:visible', val); // 同步 visible 值
    }
  }
}
</script>

<style lang="less" scoped>
.richText-content {
  background-color: #FFFFFF;
  margin-top: 18px;
  padding: 40px;

  /deep/ .ql-container.ql-snow {
    border: none;
  }
}

.text {
  white-space: pre-wrap;
  /* 保留换行和空格 */
  word-break: break-word;
  font-size: 16px;
  line-height: 30px;
  color: #000;
  text-align: left;
  height: 500px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/modal/index3.vue